import React, { useEffect, useState } from 'react';
import { devApi } from '../../services/api';
import {
  PageTitle,
  PageDescription,
  Card,
  Table,
  ErrorMessage,
  LoadingMessage,
} from './styles';

export default function DevUsers() {
  const [users, setUsers] = useState<any[]>([]);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    devApi
      .getUsers()
      .then((res) => {
        if (!cancelled) {
          setUsers(Array.isArray(res) ? res : []);
          setError(null);
        }
      })
      .catch((err: any) => {
        if (!cancelled) {
          setError(err?.response?.data?.message || err?.message || 'Failed to load users');
          setUsers([]);
        }
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  if (loading) {
    return <LoadingMessage>Loading users…</LoadingMessage>;
  }
  if (error) {
    return (
      <>
        <PageTitle>Users</PageTitle>
        <ErrorMessage>{error}</ErrorMessage>
      </>
    );
  }

  return (
    <>
      <PageTitle>Users</PageTitle>
      <PageDescription>All registered users: name, country, email, signup method, role.</PageDescription>
      <Card>
        <Table>
          <thead>
            <tr>
              <th>First name</th>
              <th>Last name</th>
              <th>Country</th>
              <th>Email</th>
              <th>Signup</th>
              <th>Role</th>
              <th>Created</th>
            </tr>
          </thead>
          <tbody>
            {users.map((u) => (
              <tr key={u.id}>
                <td>{u.firstName}</td>
                <td>{u.lastName}</td>
                <td>{u.country || '—'}</td>
                <td>{u.email}</td>
                <td>{u.signupMethod || '—'}</td>
                <td>{u.role}</td>
                <td>{u.createdAt ? new Date(u.createdAt).toLocaleDateString() : '—'}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Card>
    </>
  );
}
